import * as React from 'react';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { AnsweredModule, AnsweredQuestionnaireDto } from '../../../pages/answeredQuestionnaireTypes';
import AnsweredQuestionCluster from './AnsweredQuestionCluster';
import Module from '../common/Module';
import { sortAsc } from '../../../util/sorting';

interface Props {
  answeredModule: AnsweredModule,
  questionnaireId: number,
  enableComment: boolean,
  updateQuestionnaire: (updatedQuestionnaire: AnsweredQuestionnaireDto) => void
}

type LocalStyles = 'cluster';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  cluster: {
    marginTop: theme.spacing.unit * 2,
  }
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

class AnsweredQuestionModule extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
    this.renderCluster = this.renderCluster.bind(this);
  }

  public render() {
    return (
      <Module
        questionModule={this.props.answeredModule}
        renderCluster={this.renderCluster}/>
    )
  }

  private renderCluster() {
    return (
      <>
        {
          this.props.answeredModule.clusters
            .slice()
            .sort((c1, c2) => sortAsc(c1, c2))
            .map(cluster => (
              <div className={this.props.classes.cluster} key={cluster.id + 'moduleCluster'}>
                <AnsweredQuestionCluster
                  key={cluster.id}
                  enableComment={this.props.enableComment}
                  updateQuestionnaire={this.props.updateQuestionnaire}
                  answeredCluster={cluster}
                  questionnaireId={this.props.questionnaireId}/>
              </div>
            )
          )
        }
      </>
    )
  }
}

export default withStyles(localStyles)(AnsweredQuestionModule);

